import CauzePieChart from './CauzePieChart';

export default CauzePieChart;
